/**
 * Build items compatible with getFileChatGroup / ChatMessageFileResource from a chat message (IMAGE/VIDEO).
 */
export function libraryItemsFromImageVideoMessage(message) {
  if (!message) return [];

  const type = String(message.type || '').toUpperCase();
  if (type !== 'IMAGE' && type !== 'VIDEO') return [];

  const files = message.files;
  if (!Array.isArray(files) || files.length === 0) return [];

  const createdIso = message.created_at;
  const messageId = message.id;

  return files.map((file) => ({
    id: `live_${messageId}_${file.id}`,
    type,
    created_at: createdIso,
    media_file: normalizeMessageFileToLibraryMediaFile(file),
  }));
}

function normalizeMessageFileToLibraryMediaFile(file) {
  if (!file || typeof file !== 'object') {
    return {};
  }

  const thumb =
    file.thumbnail && typeof file.thumbnail === 'object' ? file.thumbnail : {};

  return {
    id: file.id,
    name: file.name,
    path: file.path,
    url: file.url,
    thumbnail: {
      small_thumb: thumb.small_thumb ?? null,
      medium_thumb: thumb.medium_thumb ?? null,
      regular_thumb: thumb.regular_thumb ?? null,
    },
    extension: file.extension,
    file_size: file.file_size,
    width: file.width,
    height: file.height,
  };
}
